module.exports = "/assets/1cb0206c9062a9457597392a82d6c8fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/SW.png
// module id = 2957
// module chunks = 0